<ion-app>
  <app-loading-animation></app-loading-animation>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
